import baseV3Service from './base/baseV3Service.js';

var ScanRequestStatus;
(function (ScanRequestStatus) {
    ScanRequestStatus["SKIPPED"] = "SKIPPED";
    ScanRequestStatus["CANCELED"] = "CANCELED";
    ScanRequestStatus["SCHEDULED"] = "SCHEDULED";
    ScanRequestStatus["REQUESTED"] = "REQUESTED";
    ScanRequestStatus["COMPLETED"] = "COMPLETED";
})(ScanRequestStatus || (ScanRequestStatus = {}));
const getScanRequests = (config) => {
    return baseV3Service.get("scan-requests", config);
};
const createScanRequestPreview = (communityId, payload, config) => {
    return baseV3Service.post(`auto-scan/preview/${communityId}`, payload, config);
};
const createScanRequest = (payload, config) => {
    return baseV3Service.post("scan-requests", payload, config);
};
const bulkUpdateScanRequest = (payload, config) => {
    return baseV3Service.put("scan-requests", payload, config);
};
const updateScanRequest = (scanRequestId, payload, config) => {
    return baseV3Service.put(`scan-requests/${scanRequestId}`, payload, config);
};
const deleteScanRequest = (scanRequestId, config) => {
    return baseV3Service.delete(`scan-requests/${scanRequestId}`, config);
};
const getScansRequestsByCommunities = (config) => {
    return baseV3Service.get("scan-requests/communities/count", config);
};
const sendScheduleScansConfirmationEmail = (scanRequestIds, config) => {
    return baseV3Service.post("scan-requests/scheduled-confirmation", { ids: scanRequestIds }, config);
};
const getPhotoshoots = (config) => {
    return baseV3Service.get("photoshoots", config);
};

export { ScanRequestStatus, bulkUpdateScanRequest, createScanRequest, createScanRequestPreview, deleteScanRequest, getPhotoshoots, getScanRequests, getScansRequestsByCommunities, sendScheduleScansConfirmationEmail, updateScanRequest };
